export default __webpack_public_path__ + "cff5e2f5ae0806e5c0ff63ef141960c1.woff2";